import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import "react-phone-input-2/lib/style.css";
import CloseIcon from "@mui/icons-material/Close";
//region [[ Styles ]]

//endregion [[ Styles ]]
const CloseButton = styled(IconButton)({
  position: "absolute",
  top: 5,
  right: 5,
});
//region [[ Props ]]

export interface InviteDialogProps {
  onClose: () => void;
  children?: React.ReactNode;
  title: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

export const InviteDialog = ({ ...props }: InviteDialogProps) => {
  return (
    <Dialog
      open={true}
      onClose={props.onClose}
      aria-labelledby="patient-dialog-title"
      aria-describedby="patient-dialog-description"
    >
      <CloseButton onClick={props.onClose}>
        <CloseIcon />
      </CloseButton>
      <DialogTitle id="patient-dialog-title">{props.title}</DialogTitle>
      <DialogContent>{props.children}</DialogContent>
    </Dialog>
  );
};
